const env = process.env.REACT_APP_ENV

// The page to return to is appended by redirectToLogin in session.js, at the time of the redirect.
const envConfig = {
  dev: {
    LOGIN_URL: 'https://test-lmit-roomcheckin-nprd-ping-6ryorx7kka-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=',
    API_URL: 'http://localhost:8080'
  },
  test: {
    LOGIN_URL: 'https://test-lmit-roomcheckin-nprd-ping-6ryorx7kka-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=',
    API_URL: 'https://test-roomcheckin-api-6ryorx7kka-ew.a.run.app'
  },
  prod: {
    LOGIN_URL: 'https://prod-lmit-roomcheckin-prd-ping-fn2klqucpq-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=',
    API_URL: 'https://prod-roomcheckin-api-fn2klqucpq-ew.a.run.app'
  },
}

export default envConfig[env]